export default __webpack_public_path__ + "static/itcahi-2dd5d3e71fca91f71a7024335ddddce9.jpg";